import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TableDocument from "../../TableDocument";
import { api, get } from "../../../../utils/api";
import FilterModal from "../../../../Components/Common/FilterModal";
import TopMenu from "../../TopMenu";
import { companyId } from "../../../../utils/companyId";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import ViewDetailsDrawerRefrigeration from "../../ViewDetailsDrawerRefrigeration";
import ViewDetailsDrawerFireExtinguisher from "../../ViewDetailsDrawerFireExtinguisher";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import ViewDetailsDrawerIndustrial from "../../ViewDetailsDrawerIndustrial";
import ApprovalSidebar from "../../../../Layout/ApporvalSidebar";

const FugitiveEmissionDocuments = () => {
  const { user } = useUser();
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState(
    "Refrigeration & Air Conditioning"
  );
  const [url, setUrl] = useState("air");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [columnWidth, setColumnWidth] = useState(
    user?.companyAdmin
      ? "12% 15% 15% 10% 10% 10% 17% 8%"
      : "12% 12% 18% 15% 10% 18% 8%"
  );

  const widthList = (type) => {};

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: 10,
        facilityList: selectedFacility.join(","),
        company: companyId,
        createdBy: companyId,
      }).toString();

      let apiurl =
        url === "air"
          ? `${api}/scope1/fugitiveEmission/approvalList?${queryParams}`
          : url === "industry"
          ? `${api}/scope1/fugitiveEmission/listData?${queryParams}`
          : // ? `${api}/scope1/fireEmission/approvalList?${queryParams}`
            // : `${api}/scope1/fugitiveEmission/listData?${queryParams}`;
            `${api}/scope1/fireEmission/approvalList?${queryParams}`;

      const response = await get(apiurl);
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  const fetchDataCallback = async () => {
    await fetchData();
  };
  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility]);

  const heading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      title: "Emission Source",
      key: "emissionSource",
    },
    {
      title: "Type of Substance",
      key: "typeOfSubstance",
    },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const fireheading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      title: "Emission Source",
      key: "fugitiveEmissionSource",
    },
    {
      title: "Type of Substance",
      key: "typeOfSubstance",
    },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);
  const industryHeading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    { title: "Consumption Period", key: "consumptionPeriod" },

    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      title: "Product",
      key: "productName", // You will need to populate and send this field from backend if not already
    },
    // {
    //   title: "Quantity Produced",
    //   key: "quantityProduced", // Optional - you can extract `value` and `unit` inside renderer
    // },
    // {
    //   title: "Total Emission",
    //   key: "totalEmission",
    // },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const industryData = [
    { title: "Consumption Period", key: "consumptionPeriod" },
    { title: "Product", key: "productName" },
    {
      title: "Quantity Produced",
      key: "quantityProduced", // Or break into value/unit if you're formatting
    },
    {
      title: "Total Emission",
      key: "totalEmission",
    },
    {
      title: "Status",
      key: "requestStatus",
    },
  ];

  const fireData = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    {
      title: "Emission Source",
      key: "fugitiveEmissionSource",
    },
    {
      title: "Type of Substance",
      key: "typeOfSubstance",
    },
    {
      title: "Status",
      key: "requestStatus",
    },
  ];
  const airData = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    {
      title: "Emission Source",
      key: "fugitiveEmissionSource",
    },
    {
      title: "Type of Substance",
      key: "typeOfSubstance",
    },
    {
      title: "Status",
      key: "requestStatus",
    },
  ];
  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Origin",
      type: "option",
      key: "origin",
      value: ["filterOrigin"],
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: ["filterDestination"],
    },
    {
      title: "Freight Load (Tonnes)",
      type: "limit",
      key: "load",
      value: ["one", "two"],
    },
  ];

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
  };

  const toggleData = [
    { title: "Refrigeration & Air Conditioning", url: "air" },
    { title: "Fire Extinguisher", url: "fire" },
    { title: "Industrial Process", url: "industry" },
  ];
  return (
    <MainDashboardLayout sidebar={<ApprovalSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
      <>
        <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
        <TopMenu
          {...{
            setDrawerFilterOpen: setIsFilterModalOpen,
            selectedMonth,
            setSelectedMonth,
            selectedYear,
            setSelectedYear,
            selectedOption,
            handleToggle,
            filterApplied: isFiltersApplied,
            toggleData,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            selectedFacility,
            setSelectedFacility,
          }}
          heading={"Fugitive Emission"}
        />
        <TableDocument
          data={data}
          documnets={["documents"]}
          totalPages={1}
          headers={
            url === "air"
              ? heading
              : url === "fire"
              ? fireheading
              : industryHeading
          }
          columnWidth={
            url === "industry" ? "12% 25% 25% 15% 15% 8%" : columnWidth
          }
          setsnackOpen={setsnackOpen}
          fetchDataCallback={fetchDataCallback}
          apiUrl={
            url === "air"
              ? `${api}/scope1/fugitiveEmission/apporveOrReject`
              : url === "fire"
              ? `${api}/scope1/fireEmission/apporveOrReject`
              : `${api}/scope1/fugitiveEmission/apporveOrRejectReq`
          }
          viewheaders={
            url === "air" ? airData : url === "fire" ? fireData : industryData
          }
          viewPage={
            url === "air"
              ? ViewDetailsDrawerRefrigeration
              : url === "fire"
              ? ViewDetailsDrawerFireExtinguisher
              : ViewDetailsDrawerIndustrial
          }
        />
        <FilterModal
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          filters={filterData}
          onFilterChange={handleFilterChange}
          title="Filter"
        />
      </>
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default FugitiveEmissionDocuments;
